export default [
  {
    path: '/my-orders',
    name: 'sales.my-orders',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/sales/my-orders/list/index')
  },
  {
    path: '/my-orders/:id',
    name: 'sales.my-orders.view',
    meta: {
      authRequired: true
    },
    props: route => ({
      orderId: route.params.id
    }),
    component: () => import('@/router/views/sales/my-orders/view/index')
  }
]
